// import Navbar from "./Navbar";
import Footer from "./Footer";
import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./features/AuthContext";
import Navbar from "./Navbar";
import { Toaster } from "react-hot-toast";
import GlobalLoader from "../services/GlobalLoader";
import SideBar from "./SideBar";


export default function Root() {
  const navigate = useNavigate();
  const { isAuthenticated, login, logout } = useAuth();

  return (
    <>
      <Navbar />
      <GlobalLoader />
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          success: {
            style: {
              background: "#4CAF50", // Green for success
              color: "#fff", // White text
              padding: "10px 20px", // Adequate padding for better text alignment
              borderRadius: "8px", // Rounded corners for a softer look
              fontWeight: "500", // Bold text for emphasis
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
              fontSize: "14px", // Slightly bigger font for readability
              transition: "all 0.3s ease-in-out", // Smooth animation for transitions
            },
          },
          error: {
            style: {
              background: "#F44336", // Red for errors
              color: "#fff", // White text for contrast
              padding: "10px 20px",
              borderRadius: "8px",
              fontWeight: "500",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              fontSize: "14px",
              transition: "all 0.3s ease-in-out",
            },
          },
        }}
      />
      <div id="detail" className="flex min-h-screen">
        {/* <SideBar /> */}

        <main className="flex-1 overflow-y-auto pl-4 pt-4 pr-4">
          <Outlet />
          <Footer />
        </main>
      </div>
    </>
  );
}